<template>
  <div id="app">
    <!-- <Nav class="nav" /> -->
    <router-view />
    <!-- <div id="footer" class="seite">footer</div> -->
  </div>
</template>

<script>
import "vue-slider-component/theme/default.css";
export default {
  name: "App",
  components: {
    // Nav
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Josefin+Sans");
@import url("https://use.typekit.net/jsu0gih.css");

html,
body {
  height: 100%;
}
#app {
  font-family: "Josefin Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100%;
  width: 100%;
  height: auto;
}

.custom-headline {
  font-family: crackhouse, sans-serif;
}

.headline {
  font-size: 3.2rem;
  font-weight: bold;
  color: white;
}

.vertical-center {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  width: 100%;
}

.nav {
  padding: 30px;
}

.btn.disabled {
  pointer-events: none;
}
/* REGISTER / LOGIN */
.register .card,
.login .card {
  border: none;
  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.75);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.75);
}

.register,
.login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("./assets/background_01.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.dashboard,
.highscore {
  background-color: #0b2137;
  min-height: 100vh;
  color: white;
}

.dashboard-container,
.highscore-container {
  margin-top: -120px;
}

.quick-info {
  width: 100%;
  padding-top: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.footer-center {
  display: flex;
  justify-content: center;
  margin-top: -10px;
}

.register-card,
.login-card {
  max-width: 500px;
  text-align: left;
}

.login-card ::placeholder,
.register-card ::placeholder,
.card-input-wrapper .material-design-icon__svg,
.configurator-card ::placeholder {
  color: rgba(0, 0, 0, 0.3) !important;
  font-weight: normal;
}

.login-card input,
.login-card select,
.login-card textarea,
.register-card input,
.register-card select,
.register-card textarea,
.configurator-card input,
.configurator-card select,
.configurator-card textarea {
  color: #0178b7 !important;
  font-weight: bold;
}

.card-design .card-body {
  color: white;
  background: linear-gradient(to bottom, #0178b7, #0b2137 35%);
  max-width: 415px;
}

.card-headline {
  text-align: center;
  padding-bottom: 20px;
}

.card-input-container {
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
}

.card-input-wrapper {
  background-color: white;
  color: black;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}

.card-input-wrapper .input-group-text {
  width: 48px;
  border: none;
  background-color: white;
}

.card-input-wrapper .material-design-icon__svg {
  width: 22px;
  height: 22px;
}

.card-input-wrapper .input-with-icon {
  border: none;
}

.card-hr {
  margin: 10px -20px;
}

.card-input-description {
  font-weight: bold;
  /* padding-top: 10px; */
  padding-bottom: 5px;
}
.card-input-description:first-child {
  padding-top: 20px;
}

.card-body-confirm {
  padding-top: 20px;
  width: 100%;
}

.card-body-confirm .btn {
  width: 100%;
  font-weight: bold;
  background: linear-gradient(to top, #015f91, #2780cc);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

.missing-token {
  background-color: white;
  color: black;
  padding: 10px 10px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}

.missing-token .btn {
  color: white;
}

.confirm-note {
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  margin-top: -15px;
  margin-bottom: 20px;
}

.card-body-footer {
  color: rgba(255, 255, 255, 0.45);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 25px;
}

.card-body-footer .link:hover,
.footer .link:hover {
  cursor: pointer;
  color: white;
}

.register .img-background-fade,
.login .img-background-fade {
  display: none;
}

.card-headline .logo {
  position: relative;
  height: 150px;
  width: 150px;
}

/* NAV */
.nav-spacer {
  background: linear-gradient(
      to bottom,
      rgba(11, 33, 55, 0) 70%,
      rgba(11, 33, 55, 1)
    ),
    url("./assets/background_01.jpg") no-repeat center center;
  -webkit-background-size: cover;
  background-size: cover;
  min-width: 100%;
  min-height: 40vh;
}

.custom-control.custom-radio {
  margin-left: 10px;
  margin-right: 10px;
}

.custom-control-label::before {
  background: none !important;
}

.rainbow {
  background: linear-gradient(
    to right,
    orange,
    #f0dc1e,
    #8cc83c,
    #00dcdc,
    #14b4f0,
    violet
  );
}

.farbspiel-1 {
  background: linear-gradient(to right, #00dcdc, #dc00dc, #f0dc1e);
}

.farbspiel-2 {
  background: linear-gradient(to right, #14b4f0, white, #14b4f0, white);
}

.farbspiel-3 {
  background: linear-gradient(to right, #f0dc1e, #e63232, #f0dc1e, #e63232);
}

.farbspiel-4 {
  background: linear-gradient(to right, #00dcdc, #dc00dc, #00dcdc, #dc00dc);
}

hr {
  border-top: 2px solid rgba(255, 255, 255, 0.1) !important;
}

.modal-title {
  font-size: 1.5rem !important;
  font-weight: bold !important;
  color: #0178b7 !important;
}

.navigation-buttons {
  align-self: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-right: 20px;
  max-width: 350px;
  min-width: 100px;
}

.footer-buttons .back-button {
  color: white;
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.3);
  margin-right: 10px;
}

.footer-buttons .back-button:hover,
.footer-buttons .back-button:focus {
  color: white;
  background-color: rgba(255, 255, 255, 0.22);
}

.footer-buttons {
  display: flex;
  flex-direction: row;
  justify-items: center;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: -5px;
}

.btn.start-btn {
  background: url("./assets/button_bg.png") no-repeat center center;
  background-size: cover;
  border: none;
  /*height: 40px;*/
  font-weight: bold;
  color: white;
}

.btn.start-btn:hover,
.btn.start-btn:focus {
  /*border: 1px solid #0178b7;*/
  opacity: 0.9;
  color: white;
}

.btn.abort-btn {
  background: none;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  height: 40px;
  font-weight: bold;
}

.btn.abort-btn:hover,
.btn.abort-btn:focus {
  background-color: rgba(255, 255, 255, 0.22);
  color: white;
  font-weight: bold;
}

.list-group-item.active {
  background: linear-gradient(to right, #0178b7, #00a7ff);
  border: none;
}

.tabs {
  margin-top: 20px;
  background-color: white;
  border-radius: 3px;
}

.tabs .nav {
  padding: 0;
}

.tabs .nav-item {
  background-color: rgba(1, 120, 183, 0.05);
}

.nav .nav-link {
  color: rgba(1, 120, 183, 0.5) !important;
}

.nav .nav-link.active {
  color: #0178b7 !important;
  font-weight: bold;
}

.logoStart {
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background-image: url("./assets/logo.svg");
  background-size: cover;
  background-repeat: no-repeat;
}

@media (max-width: 576px) {
  .register,
  .login {
    background: none;
  }

  .register .card,
  .login .card {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    min-height: 100vh;
  }

  .register .card-design,
  .login .card-design {
    min-width: 100%;
  }

  .card-design .card-body {
    width: auto;
    min-width: 100%;
    min-height: auto;
    height: auto;
    background: #0b2137;
  }

  .card-body-footer {
    margin: auto;
  }

  .login .img-background-fade,
  .register .img-background-fade {
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 250px;
    mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1),
      rgba(0, 0, 0, 0) 80%
    );
  }

  .card-headline .logo {
    /*position: absolute;*/
    left: 50%;
    top: 35px;
    transform: translateX(-50%);
    height: 200px;
    width: 200px;
  }

  .card-headline .custom-headline {
    margin-top: 30px;
  }

  .mobile-head {
    background-color: rgba(11, 33, 55, 1);
  }

  .register .card-body,
  .login .card-body {
    margin-top: -8vh;
  }

  .footer-buttons {
    margin-top: 15px;
    margin-bottom: 50px;
  }
}
</style>
